export const PageTitle = "pageTitle";
export const PageAction = "pageAction";
export const PageSubAction = "pageSubAction";
export const PageActionPreSlot = "pageActionPreSlot";

export const cell1Icon = 60;
export const cell2Icons = 112;
export const cell3Icons = 152;

export const AnalyticsSpacing = 2;
